import { useState } from 'react';
import { Spinner } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { QBOAccountField } from "../../../integrations/Accounting/QBOAccountField";
import { useStoreActions } from "../../../store/store-context";
import { Accounting } from "../../../types/api.model";
import { getAccountingDetails } from "../../../integrations/Accounting/accounting.utils";
import styles from "./QBOSetupStep.module.scss";
import { capitalize } from 'lodash-es';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export let LinkType = /*#__PURE__*/function (LinkType) {
  LinkType["Bank"] = "bank";
  LinkType["Expense"] = "expense";
  LinkType["Clearing"] = "clearing";
  return LinkType;
}({});
export function AccountRow(_ref) {
  let {
    linkType,
    initialValue,
    qboAccounts,
    placeholder,
    noOptionsText = "No ".concat(getAccountingDetails(Accounting.QBO).name, " accounts")
  } = _ref;
  const {
    api
  } = useStoreActions();
  const [selectedOption, setSelectedOption] = useState(() => qboAccounts === null || qboAccounts === void 0 ? void 0 : qboAccounts.find(account => account.id === initialValue));
  const [mapStatus, setMapStatus] = useState(() => selectedOption ? MapStatus.Saved : MapStatus.NotSaved);
  const onChange = async account => {
    if (!account) return;
    setMapStatus(MapStatus.Saving);
    setSelectedOption(account);
    try {
      await api.accounting.linkAccount({
        accounting: Accounting.QBO,
        data: {
          linkType,
          integratedId: account.id
        }
      });
      setMapStatus(MapStatus.Saved);
    } catch (e) {
      setMapStatus(MapStatus.Failed);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.accountRow,
    "data-testid": "".concat(linkType, "-account-wrapper"),
    children: [/*#__PURE__*/_jsx(QBOAccountField, {
      "data-testid": "".concat(linkType, "-account"),
      options: qboAccounts || [],
      onChange: onChange,
      selectedOption: selectedOption,
      textFieldProps: {
        placeholder,
        error: mapStatus === MapStatus.Failed,
        minWidth: 412,
        label: "".concat(capitalize(linkType), " Account")
      },
      noOptionsText: noOptionsText
    }), /*#__PURE__*/_jsx(SaveStatus, {
      mapStatus: mapStatus
    })]
  });
}
var MapStatus = /*#__PURE__*/function (MapStatus) {
  MapStatus["Saved"] = "saved";
  MapStatus["NotSaved"] = "notSaved";
  MapStatus["Failed"] = "failedToSave";
  MapStatus["Saving"] = "saving";
  return MapStatus;
}(MapStatus || {});
export function SaveStatus(props) {
  const {
    mapStatus
  } = props;
  let element;
  switch (mapStatus) {
    case MapStatus.Saved:
      element = /*#__PURE__*/_jsx("div", {
        className: styles.mapped,
        "data-testid": "saved",
        children: /*#__PURE__*/_jsx(Checkmark, {})
      });
      break;
    case MapStatus.NotSaved:
      element = null;
      break;
    case MapStatus.Failed:
      element = null;
      break;
    case MapStatus.Saving:
      element = /*#__PURE__*/_jsx(Spinner, {
        "data-testid": "save-spinner",
        size: 32
      });
      break;
    default:
      element = null;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "save-status",
    className: styles.saveStatus,
    children: element
  });
}